var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"case-study-screen-component-conclusion"},[_c('div',{staticClass:"case-study-screen-component-conclusion__title"},[_vm._v(" Conclusion ")]),(_vm.text)?_c('div',{staticClass:"case-study-screen-component-conclusion__text"},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }